import { useGetDocumentOrderFilterDimensions } from "hooks/api/documents/documentFilterDimensions";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { removeNullable } from "services/apiHelpers";
import {
  CheckboxListFilter,
  FilterOption,
} from "../GenericFilters/CheckboxListFilter";
import { FilterProps } from "../filter-definition";

export const OrdersShipToFilter = ({ variant }: FilterProps) => {
  const cardCodes = useSelectedCustomerCode();

  const { data, isLoading } = useGetDocumentOrderFilterDimensions(cardCodes);

  const shipToOptions: FilterOption[] = removeNullable(
    data?.shipToAddresses?.map((shipToAddress) => ({
      label: shipToAddress.Name,
      value: shipToAddress.Code,
    })) ?? []
  );

  return (
    <CheckboxListFilter
      filterKey="shipTo"
      name="Ship To"
      variant={variant}
      filterOptions={shipToOptions}
      isLoading={isLoading}
    />
  );
};
